import i18n from "@plugins/i18n";

export default function (editor) {
  editor.ui.registry.addMenuButton("other_formatting", {
    tooltip: i18n.t("tinymce_plugin_other_formatting_icon_button_tooltip"),
    icon: "change-case",
    fetch: (callback) => {
      const items = [
        {
          type: "togglemenuitem",
          text: "Strikethrough",
          icon: "strike-through",
          onAction: () => editor.execCommand("Strikethrough"),
          onSetup: (api) => {
            const isActive = editor.queryCommandState("Strikethrough");
            api.setActive(isActive);
            return () => ({});
          },
        },
        {
          type: "togglemenuitem",
          text: "Subscript",
          icon: "subscript",
          onAction: () => editor.execCommand("Subscript"),
          onSetup: (api) => {
            const isActive = editor.queryCommandState("Subscript");
            api.setActive(isActive);
            return () => ({});
          },
        },
        {
          type: "togglemenuitem",
          text: "Superscript",
          icon: "superscript",
          onAction: () => editor.execCommand("Superscript"),
          onSetup: (api) => {
            const isActive = editor.queryCommandState("Superscript");
            api.setActive(isActive);
            return () => ({});
          },
        },
      ];
      callback(items);
    },
  });
}
